import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import LanguageStrings from '../../../i18n/locales'

export interface deviceDeleteState {
  isLoading: boolean
  error: string | undefined
  deviceDeleteData: string | undefined
  httpStatus: number | undefined
}

export const initialState: deviceDeleteState = {
  isLoading: true,
  error: undefined,
  deviceDeleteData: undefined,
  httpStatus: 0
}

const DeviceManagementStrings =
  LanguageStrings().DeviceManagementCollectionStrings.TableComponent

const deviceDeleteSlice = createSlice({
  name: 'deviceDelete',
  initialState,
  reducers: {
    deviceDeleteLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        deviceDeleteData: undefined,
        httpStatus: 0
      }
    },
    deviceDeleteUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        deviceDeleteData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    deviceDeleteErrorAction: (state, action: PayloadAction<{ errorMessage: string | undefined, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage ?? DeviceManagementStrings.NetworkError,
        deviceDeleteData: undefined,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  deviceDeleteLoadingAction,
  deviceDeleteUpdateAction,
  deviceDeleteErrorAction
} = deviceDeleteSlice.actions

export default deviceDeleteSlice.reducer
